var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70341 15.7929C2.46189 16.5514 3.69162 16.5512 4.45008 15.7927L16.0037 4.23912C16.7622 3.48066 16.7624 2.25094 16.0039 1.49245C15.2454 0.733973 14.0157 0.73416 13.2572 1.49262L1.70358 13.0462C0.945114 13.8047 0.944928 15.0344 1.70341 15.7929Z",
    fill: "#0762A3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.70341 15.7929C2.46189 16.5514 3.69162 16.5512 4.45008 15.7927L16.0037 4.23912C16.7622 3.48066 16.7624 2.25094 16.0039 1.49245C15.2454 0.733973 14.0157 0.73416 13.2572 1.49262L1.70358 13.0462C0.945114 13.8047 0.944928 15.0344 1.70341 15.7929Z",
    fill: "url(#paint0_linear_421_396)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.70341 15.7929C2.46189 16.5514 3.69162 16.5512 4.45008 15.7927L16.0037 4.23912C16.7622 3.48066 16.7624 2.25094 16.0039 1.49245C15.2454 0.733973 14.0157 0.73416 13.2572 1.49262L1.70358 13.0462C0.945114 13.8047 0.944928 15.0344 1.70341 15.7929Z",
    stroke: "#0762A3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79526 1.58409C1.03679 2.34255 1.03661 3.57228 1.79509 4.33076L13.1663 15.702C13.9248 16.4605 15.1545 16.4603 15.913 15.7018C16.6714 14.9433 16.6716 13.7136 15.9131 12.9551L4.54193 1.58392C3.78345 0.825438 2.55372 0.825622 1.79526 1.58409Z",
    fill: "#0762A3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.79526 1.58409C1.03679 2.34255 1.03661 3.57228 1.79509 4.33076L13.1663 15.702C13.9248 16.4605 15.1545 16.4603 15.913 15.7018C16.6714 14.9433 16.6716 13.7136 15.9131 12.9551L4.54193 1.58392C3.78345 0.825438 2.55372 0.825622 1.79526 1.58409Z",
    fill: "url(#paint1_linear_421_396)",
    fillOpacity: 0.4,
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79526 1.58409C1.03679 2.34255 1.03661 3.57228 1.79509 4.33076L13.1663 15.702C13.9248 16.4605 15.1545 16.4603 15.913 15.7018C16.6714 14.9433 16.6716 13.7136 15.9131 12.9551L4.54193 1.58392C3.78345 0.825438 2.55372 0.825622 1.79526 1.58409Z",
    stroke: "#0762A3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_421_396",
    x1: 6.71329,
    y1: 6.50233,
    x2: 10.374,
    y2: 11.6085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_421_396",
    x1: -5.22039,
    y1: -5.43156,
    x2: -8.6846,
    y2: -0.854469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/cross-icon.3ab0d3f85e48cce0d85b55f0b049140d.svg";
export { ForwardRef as ReactComponent };